import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import {
  adminRoleConfirmToken,
  confirmationMatches,
  displayUserName,
} from "../../utils/adminUsers";

const AdminRoleConfirmDialog = ({
  open,
  user,
  makeAdmin,
  isLoading,
  error,
  onCancel,
  onConfirm,
}) => {
  const [typed, setTyped] = useState("");
  const token = adminRoleConfirmToken(user);
  const name = user ? displayUserName(user) : "";

  useEffect(() => {
    if (open) setTyped("");
  }, [open, user]);

  const ready = confirmationMatches(typed, token);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {makeAdmin ? "Grant admin access" : "Remove admin access"}
      </DialogTitle>
      <DialogContent>
        <Alert severity={makeAdmin ? "warning" : "error"} sx={{ mb: 2 }}>
          {makeAdmin
            ? `${name} will get the full admin console: users, ops, and trivia.`
            : `${name} will lose the admin console immediately.`}
        </Alert>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          Type <strong>{token}</strong> to confirm.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label="Confirmation"
          value={typed}
          onChange={(event) => setTyped(event.target.value)}
          autoComplete="off"
        />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          color={makeAdmin ? "warning" : "error"}
          variant="contained"
          disabled={!ready || isLoading}
          onClick={() => onConfirm(user)}
        >
          {isLoading
            ? "Saving…"
            : makeAdmin
            ? "Grant admin"
            : "Remove admin"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminRoleConfirmDialog;
